import React from "react";
import Flexbox from "flexbox-react";
import "./MyAssessmentView.css";

const ReadOnlyNotice = () => {
  return (
    <Flexbox
      alignItems="center"
      className="notice-box"
      style=
      {{padding:'13px 17px'}}
    >
      <div className="notice-icon-box" style={{ marginRight: "8px" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M3.99984 14.6665C3.63317 14.6665 3.31939 14.5361 3.0585 14.2752C2.79761 14.0143 2.66695 13.7003 2.6665 13.3332V6.6665C2.6665 6.29984 2.79717 5.98606 3.0585 5.72517C3.31984 5.46428 3.63362 5.33362 3.99984 5.33317H4.6665V3.99984C4.6665 3.07762 4.99162 2.29162 5.64184 1.64184C6.29206 0.99206 7.07806 0.666949 7.99984 0.666504C8.92162 0.66606 9.70784 0.991171 10.3585 1.64184C11.0092 2.2925 11.3341 3.0785 11.3332 3.99984V5.33317H11.9998C12.3665 5.33317 12.6805 5.46384 12.9418 5.72517C13.2032 5.9865 13.3336 6.30028 13.3332 6.6665V13.3332C13.3332 13.6998 13.2027 14.0138 12.9418 14.2752C12.6809 14.5365 12.3669 14.6669 11.9998 14.6665H3.99984ZM3.99984 13.3332H11.9998V6.6665H3.99984V13.3332ZM7.99984 11.3332C8.3665 11.3332 8.6805 11.2027 8.94184 10.9418C9.20317 10.6809 9.33362 10.3669 9.33317 9.99984C9.33273 9.63273 9.20228 9.31895 8.94184 9.05851C8.68139 8.79806 8.36739 8.66739 7.99984 8.6665C7.63228 8.66562 7.3185 8.79628 7.0585 9.05851C6.7985 9.32073 6.66784 9.63451 6.6665 9.99984C6.66517 10.3652 6.79584 10.6792 7.0585 10.9418C7.32117 11.2045 7.63495 11.3349 7.99984 11.3332ZM5.99984 5.33317H9.99984V3.99984C9.99984 3.44428 9.80539 2.97206 9.4165 2.58317C9.02762 2.19428 8.55539 1.99984 7.99984 1.99984C7.44428 1.99984 6.97206 2.19428 6.58317 2.58317C6.19428 2.97206 5.99984 3.44428 5.99984 3.99984V5.33317Z"
            fill="#C57D00"
          />
        </svg>
      </div>
      <span className="notice-text" >
        This review has been submitted and is now in read-only mode. You cannot make any further changes.
      </span>
    </Flexbox>
  );
};

export default ReadOnlyNotice;
